// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface ICategorySchema {
  /** ID категории (для общих подписок) **/
  categoryId?: number;
  /** Системное название категории **/
  categoryName?: string;
  /** Тип категории **/
  categoryType?: ECategoryType;
  /** Есть ли частота оповещения **/
  hasFrequency?: boolean;
  /** Есть подписки **/
  hasItems?: boolean;
  /** Подписка на категорию активна **/
  isActive?: boolean;
  /** Заголовок категории **/
  title?: string;
}

export enum ECategoryType {
  /** Удаление **/
  'Delete' = 'delete',
  /** Общие подписки **/
  'Plain' = 'plain',
  /** Переключение вкл/выкл **/
  'Toggle' = 'toggle',
}
